// Reusable form field wrapper with label, input, and error message.
// Now delegates rendering to the theme-aware `GlassFormInput` primitive,
// preserving the original prop API + helpText support.
import React from 'react';
import { View, Text, StyleSheet, TextInputProps } from 'react-native';
import { GlassFormInput } from '@/components/admin/redesign';
import { useThemedStyles } from '@/hooks/shared/useThemeColors';

interface FormFieldProps extends TextInputProps {
  label: string;
  error?: string;
  required?: boolean;
  helpText?: string;
}

export const FormField: React.FC<FormFieldProps> = ({
  label,
  error,
  required,
  helpText,
  style,
  ...textInputProps
}) => {
  const styles = useStyles();

  return (
    <View>
      <GlassFormInput
        label={label}
        error={error}
        required={required}
        inputStyle={style as any}
        containerStyle={styles.field}
        {...textInputProps}
      />
      {helpText && !error ? <Text style={styles.helpText}>{helpText}</Text> : null}
    </View>
  );
};

const useStyles = () =>
  useThemedStyles(({ colors }) =>
    StyleSheet.create({
      field: {
        marginBottom: 20,
      },
      helpText: {
        color: colors.text.dim,
        fontSize: 12,
        marginTop: 4,
        marginBottom: 16,
      },
    }),
  );
